import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import SwitchOnKitSectionHeader from "../SwitchOnKitItemBuilder/SwitchOnKitSectionHeader";

const ITEMS = [
  { code: "AB_WATER_BATTERY" },
  { code: "AB_WATER_ORINGS" },
  { code: "AB_WATER_CLIP" },
];

const WaterproofSolutionIncludedItems = ({ rightSelected, leftSelected, linked, setLinked, getOptionsForSide, selectedOptions, setOption }) => {
  const renderSide = (side) => ITEMS.map((itemDefinition) => {
    const option = getOptionsForSide(side).find((entry) => entry.Code === itemDefinition.code);
    if (!option) return null;
    const checked = selectedOptions[side][option.Name] === "Yes";
    return <div className="waterproof-included-item" key={`${side}-${option.Code}`}>
      <label><input type="checkbox" checked={checked} onChange={(event) => setOption(side, option, event.target.checked ? "Yes" : "")} /> {option.Name}</label>
    </div>;
  });

  return <div className="waterproof-included-items order-builder-component">
    <SwitchOnKitSectionHeader title="Choose a Waterproof Solution" rightSelected={rightSelected} leftSelected={leftSelected} linked={linked} setLinked={setLinked}>
      <Col md={6}>{rightSelected && renderSide("R")}</Col>
      <Col md={6} className="left-side">{leftSelected && renderSide("L")}</Col>
    </SwitchOnKitSectionHeader>
  </div>;
};

WaterproofSolutionIncludedItems.propTypes = {
  rightSelected: PropTypes.bool, leftSelected: PropTypes.bool, linked: PropTypes.bool,
  setLinked: PropTypes.func, getOptionsForSide: PropTypes.func,
  selectedOptions: PropTypes.object, setOption: PropTypes.func,
};

export default WaterproofSolutionIncludedItems;
